<template>
  <div>
    <slot name="prepend"></slot>
    <div class="pinContainer" @click="setFocus()">
      <span>{{ title }}</span>
      <div class="pins">
        <el-input
          class="pin"
          @keyup.backspace.native="backspacePressed"
          type="number"
          v-for="n in pinLenght"
          :key="n"
          :ref="`digit${n}`"
          v-model="pin[n - 1]"
          max="9"
          @input="pinChanged(n, pin[n])"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinInput',
  props: {
    pinLenght: { required: true, type: Number },
    title: { required: false, type: String, default: '' }
  },
  data() {
    return {
      pin: []
    };
  },
  methods: {
    pinChanged(index, value) {
      this.pin = this.pin
        .filter(digit => !isNaN(digit)) // Filter all non digit values
        .map(pin => pin.slice('-1')); // Make each input to have one digit lenght

      if (index < this.pinLenght) {
        this.setFocus();
      }

      this.$emit('updatePin', this.pin.join(''));
    },

    setFocus() {
      if (this.pin.length >= this.pinLenght) {
        this.$refs[`digit${this.pin.length}`][0].focus();
      } else {
        this.$refs[`digit${this.pin.length + 1}`][0].focus();
      }
    },

    backspacePressed(event) {
      this.pin.pop();
      this.setFocus();
    }
  }
};
</script>

<style scoped>
.pinContainer {
  display: flex;
  flex-direction: column;
  text-align: center;
  background-color: #f4f4f4;
  border-radius: 5px;
  padding: 2px 12px 16px;
}

.pinContainer > span {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: lighter;
}

.pins {
  display: flex;
  justify-content: space-around;
}

.pin {
  height: 35px;
  width: 35px;
  text-align: center;
}

.el-input {
  padding: 0 1px;
  border-radius: 10px;
  overflow: hidden;
}

.el-input__suffix {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Forms/PinInput/index.vue